import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import { MoreVertIcon } from 'assets/materialIcons/materialIcons';

const DropDownActionsMenu = (props) => {
    const { children, defaultStyle, record, resource } = props;

    if (!children.length === (children.length > 0) || !record) {
        return null;
    }

    const styles = {
        horizontal: 'left',
        vertical: 'top',
    };

    const childElements = React.Children.map(children, (child) => {
        return React.cloneElement(child, {
            record: record,
            resource: resource,
        });
    });

    return (
        <div style={ defaultStyle }>
            <IconMenu
                iconButtonElement={
                    <IconButton>
                        <MoreVertIcon />
                    </IconButton>
                }
                anchorOrigin={ styles }
                targetOrigin={ styles }
            >
                { childElements }
            </IconMenu>
        </div>
    );
};

DropDownActionsMenu.defaultProps = {
    defaultStyle: {
        textAlign: 'center',
    },
};

DropDownActionsMenu.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.array,
    ]),
    defaultStyle: PropTypes.object,
    record: PropTypes.object,
    resource: PropTypes.string,
};

export default DropDownActionsMenu;



// WEBPACK FOOTER //
// ./src/components/field/DropDownActionsMenu/DropDownActionsMenu.js